<template>
  <v-app style="font-family: NeueMontreal">
    <v-main :style="computedStyle">
      <router-view />
    </v-main>
    <Toaster></Toaster>
  </v-app>
</template>

<script>
import Chart from 'chart.js';
import axios from "axios";
import styles from "./styles/driblab.scss";
import SearchService from "./services/search.service";
import SearchBar from "./views/base/SearchBar";
import Toaster from "./views/base/Toaster";
import i18n from './i18n';

export default {
  components: {
    SearchBar,
    Toaster
  },
  data() {
    return {
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    userIsAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return (
          this.currentUser.roles.includes("ROLE_ADMIN") ||
          this.currentUser.roles.includes("ROLE_SERVICES") ||
          this.currentUser.roles.includes("ROLE_DEV")
        );
      }

      return false;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    showUserBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_USER");
      }

      return false;
    },
    currentRoute() {
      return this.$route.name;
    },
    computedStyle() {
      const isDarkMode = this.$vuetify.theme.dark; // Check if the dark theme is active
      return {
        'background': this.currentRoute && this.currentRoute.includes('embed-chart')
          ? 'transparent'
          : isDarkMode
          ? '#1f1f1fc8' // Dark theme background
          : '#efefef8f' // Light theme background
      };
    },
    isRtl () {
      return i18n.locale === 'sa'
    }
  },
  watch: {
  },
  created() {
    if (this.$store.getters['auth/language']) {
      this.$store.dispatch(
        "auth/setLanguage",
        this.$store.getters['auth/language']
      );
    }
    this.$vuetify.theme.dark = _.get(this.currentUser, "darkMode") || this.$vuetify.theme.dark;
    Chart.defaults.global.defaultFontFamily = 'NeueMontreal';
  },
  methods: {
  },
  destroyed(){
    this._props = null;
    this._watcher = null;
    this._watchers = null;
    this.$options.propsData = null;
    this.$parent = null;
    this._self = null;
    this.$children = null;
    this.$refs = null;
    this._refs = null;
  }
};
</script>

<style lang="scss" scoped>
img {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.theme--light{
  .v-content,
  .v-main {
    background: #efefef8f;
  }
}
.dir-rtl {
  direction: rtl !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue